module.exports = __webpack_public_path__ + "Flag-192.e42857e181ca4edea13f2cd4a86f06b6.svg";